import {
  CLOSE_OBSERVER,
  CLOSED_OBSERVER,
  OBSERVER_ERROR,
  RESET_OBSERVER,
} from "./actionTypes";

export const observerError = (error) => {
  return {
    type: OBSERVER_ERROR,
    payload: error,
  };
};
export const closeObserver = (chatId) => {
  return {
    type: CLOSE_OBSERVER,
    payload: chatId,
  };
};
export const closedObserver = () => {
  return {
    type: CLOSED_OBSERVER,
    payload: {},
  };
};
export const resetObserver = () => {
  return {
    type: RESET_OBSERVER,
    payload: {},
  };
};
